import React from 'react';
import './CrosswordGridDisplay.css';

const CrosswordGridDisplay = ({
  grid,
  selectedCell,
  handleCellDoubleClick,
  handleCellClick,
  isPartOfSelectedWord,
  isComplete,
  wrongCells,
}) => {
  return (
    <div className={`grid${isComplete ? ' completed' : ''}`}>
      {grid.map((row, rowIndex) => (
        <div key={rowIndex} className="row">
          {row.map((cell, colIndex) => {
            // `occupied` is the filled-cell look. A revealed cell (give-up, and
            // later the assist ladder) has no tileId — it is not a real tile —
            // so it has to opt in separately or it renders as an empty square.
            const isFilled = cell.tileId !== null || cell.isRevealed;
            const isWrong = wrongCells?.has(`${rowIndex},${colIndex}`);

            return (
              <div
                key={`${rowIndex}-${colIndex}`}
                className={`cell
                  ${cell.isBlocked ? 'blocked' : 'open'}
                  ${cell.isLocked ? 'locked' : ''}
                  ${cell.cellDisplay === null ? '' : cell.cellDisplay}
                  ${isFilled ? 'occupied' : ''}
                  ${cell.isRevealed ? 'revealed' : ''}
                  ${isWrong ? 'assist-wrong' : ''}
                  ${selectedCell?.row === rowIndex && selectedCell?.col === colIndex ? 'selected' : ''}
                  ${isPartOfSelectedWord(rowIndex, colIndex) ? 'word-highlight' : ''}
                  ${isComplete && cell.letter ? 'completed' : ''}
                `}
                onDoubleClick={() => handleCellDoubleClick(rowIndex, colIndex)}
                onClick={() => {handleCellClick(rowIndex, colIndex)}}
              >
                {cell.letter}
              </div>
            );
          })}
        </div>
      ))}
    </div>
  );
};

export default CrosswordGridDisplay;
